import ownershipList from './ownership-list.locales'

export default {
  title: 'Choisir les actifs dont vous souhaitez simuler une donation : ',
  help: 'La donation en nue-propriété permet de transmettre des biens sur une valeur réduite en fonction de l\'âge du donateur, dans la mesure où celui-ci conserve l\'usufruit',
  ownershipList,
  filter: {
    all: 'Tout afficher ({value})',
    immobilier: 'Votre patrimoine immobilier ({value})',
    financier: 'Votre patrimoine financier ({value})',
    PRODUCT_GROUP: {
      cpte_depot: 'Comptes bancaires ({value})',
      epargne: 'Épargne disponible ({value})',
    },
  },
  holder: {
    subtitle: 'Sélectionner ce donateur pour simuler la donation',
    details: {
      beneficiaries: 'Choisir les donataires :',
      barePropertyPartUsufruct: 'Définir le montant à transmettre en nue-propriété',
      barePropertyPartDonation: 'Définir le montant à transmettre',
      barePropertyPartUsufructHint: 'Il convient d\'indiquer, pour chaque donataire, la part du bien en valeur pleine propriété sur laquelle la nue-propriété sera transmise.',
      apply: 'Appliquer la réversion d\'usufruit ? ',
      tooltip: 'Avec la réversion d\'usufruit, au décès du donateur, l\'usufruit est transmis au conjoint survivant.',
      usufructInfo: 'Il peut être prévu une réversion d\'usufruit permettant au décès du donateur usufruitier un transfert de l\'usufruit au conjoint survivant. Lorsque le conjoint survivant décède à son tour, le nu-propriétaire devient alors plein propriétaire du bien sans droit de succession complémentaire.',
    },
  },
  summary: {
    repartitionByDonations: 'Valeur totale transmise par donation',
    costByDonations: 'Répartition par donataire',
    totalTransmissionDonation: 'Coût par donataire ',
    totalCost: 'Coût total',
  },
  drawer: {
    dateAcquisition: 'Date d\'acquisition',
    totalAmount: 'Valeur totale',
    informations: 'Informations',
    ownership: 'Détenteurs',
  },
}
